import React, { useEffect, useState } from "react";
import { CsrAPI } from "../apis/CsrAPI";
import { renderMarkdown } from "../utils/triloChatMarkdown";
import { CHAT_MESSAGES } from "../utils/triloChatConstants";

/**
 * TriloChatDocPanel
 *
 * Inline document panel rendered in place of a `[DOC:<id>]` marker in an
 * assistant reply. The body is fetched on mount rather than inlined in the
 * reply so a long document does not bloat the conversation payload.
 *
 * Props:
 * - contentId: Content id from the [DOC:<id>] marker
 * - sessionId: Session the document belongs to
 */
const TriloChatDocPanel = ({ contentId, sessionId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const json = await CsrAPI.getChatSessionContent({
          sessionId,
          contentId,
        });
        if (!cancelled) setData(json);
      } catch {
        if (!cancelled) setError(CHAT_MESSAGES.docPanelError);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [contentId, sessionId]);

  if (loading)
    return (
      <div className="trilochat__doc-panel trilochat__doc-panel--loading">
        {CHAT_MESSAGES.docPanelLoading}
      </div>
    );
  if (error)
    return (
      <div className="trilochat__doc-panel trilochat__doc-panel--error">
        {error}
      </div>
    );
  return (
    <div className="trilochat__doc-panel">
      {data.title && (
        <div className="trilochat__doc-panel__title">{data.title}</div>
      )}
      <div
        className="trilochat__doc-panel__content"
        dangerouslySetInnerHTML={{ __html: renderMarkdown(data.content) }}
      />
    </div>
  );
};

export default TriloChatDocPanel;
